import { dynamicSort } from '@olo-web/utils/common/functions';
import { buildModifiersWithDisplayValues, getModifierDisplayType, isModifierGroupValid } from '.';

export const createFormModifierGroups = (
  modifierGroups: IMenuItemModifierGroup[],
  defaultModifierGroups: IMenuItemDefaultModifierGroup[]
): IMenuItemModifierGroupDisplay[] => {
  return (modifierGroups || [])
    .map((mod) => {
      const defaultGroup = defaultModifierGroups?.find((d) => d.modInfoId === mod.id);
      const modifiers = buildModifiersWithDisplayValues(
        mod.modifiers,
        defaultGroup,
        mod.implicitDefaultModOptionText
      );
      const displayGroup = {
        ...mod,
        defaultGroup,
        displayType: getModifierDisplayType(mod),
        modifiers,
        isDirty: false,
      };

      return {
        ...displayGroup,
        isValid: isModifierGroupValid(displayGroup),
      };
    })
    .sort(dynamicSort('position'));
};
